import React from 'react';
import { Action, Eyebrow, ProductFrame, Icon } from './Primitives';
import './UnityHero.css';
export default function UnityHero({ assetBase, onTrial }) {
  return (
    <section className="ul-hero ul-dark" id="unity-top">
      <div className="ul-container ul-hero-grid">
        <div className="ul-hero-copy">
          <Eyebrow>Unity Learning · Create. Deliver. Adapt.</Eyebrow>
          <h1>
            Your knowledge.
            <br />
            Their next
            <br />
            <span>breakthrough.</span>
          </h1>
          <p className="ul-lead">
            Turn policies, manuals and ideas into engaging training. Create with AI, stay in
            control, and help every learner move forward.
          </p>
          <div className="ul-actions">
            <Action onClick={onTrial}>Request your free trial</Action>
            <a className="ul-button ul-button--secondary" href="#create">
              Explore Unity <Icon name="arrow" size={18} />
            </a>
          </div>
          <p className="ul-hero-trial">Ask about our 14-day trial · No credit card</p>
          <p className="ul-hero-scope">
            Explore one programme structure and one outcome. Trial access and the proposed
            10,000-credit allowance are confirmed by our team.
          </p>
        </div>
        <div className="ul-hero-visual">
          <img
            className="ul-hero-art"
            src={`${assetBase}/knowledge-sculpture.webp`}
            alt=""
            width="1536"
            height="1024"
            fetchPriority="high"
          />
          <div className="ul-hero-product">
            <div className="ul-hero-caption">
              <span>YOUR NEXT PROGRAMME STARTS HERE</span>
              <span className="ul-caption-pill">
                <Icon name="spark" size={13} /> Built in Unity
              </span>
            </div>
            <ProductFrame
              src={`${assetBase}/product/content-manager.png`}
              width={1915}
              height={908}
              crop={[328, 166, 1497, 611]}
              alt="Unity Content Manager with a programme and three content complexity options"
              eager
            />
          </div>
          <div className="ul-hero-floating">
            <Icon name="shield" size={19} />
            <div>
              <strong>Your expertise stays in control.</strong>
              <span>Build with AI. Review with confidence.</span>
            </div>
          </div>
        </div>
      </div>
      <div className="ul-container ul-hero-bottom">
        <span>ONE CONNECTED LEARNING JOURNEY</span>
        <div>
          <b>Create</b>
          <i />
          <b>Review</b>
          <i />
          <b>Deliver</b>
          <i />
          <b>Understand</b>
        </div>
      </div>
    </section>
  );
}
